package fr.manyverse.app.domain.validation

import fr.manyverse.app.domain.error.ValidationError

object CharacterValidator {

    fun validateName(name: String): Result<Unit> {
        return if (name.isBlank()) {
            Result.failure(ValidationError("Character name cannot be empty"))
        } else {
            Result.success(Unit)
        }
    }

    fun validateId(characterId: String): Result<Unit> {
        return if (characterId.isBlank()) {
            Result.failure(ValidationError("Character ID cannot be blank"))
        } else {
            Result.success(Unit)
        }
    }

    fun validateForCreation(name: String): Result<Unit> {
        validateName(name).onFailure { return Result.failure(it) }
        return Result.success(Unit)
    }

    fun validateForUpdate(
        characterId: String,
        name: String
    ): Result<Unit> {
        validateId(characterId).onFailure { return Result.failure(it) }
        validateName(name).onFailure { return Result.failure(it) }
        return Result.success(Unit)
    }
}
